import health from './health'

const segments = {
  [health.id]: health,
}

export default segments
